/*
 * File: index.tsx
 * Desc: 日期选择组件
 * File Created: 2019-12-05 17:10:58
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState, useEffect } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

interface TdDateRenderProps {
    style?: React.CSSProperties;
    className?: string;
    value?: any;
    onChange?: (value: any, date: any) => void;
    validator?: (value: any) => boolean;
    [key: string]: any 
}

/** 可编辑表格输入组件 */
const TdDateRender = (props: TdDateRenderProps) => {
    const { validator, ...rest } = props;
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    function onChange(inputValue: any, date: any) {
        if (validator && !validator(inputValue)) {
            return;
        }
        setValue(inputValue);
        props.onChange && props.onChange(inputValue, date);
    }

    return (
        <DatePicker
            {...rest}
            {...(value && { value: moment(value) })}
            style={{ width: 100, ...props.style }}
            onChange={(date, str) => {
                onChange(str, date);
            }}
        />
    );
};

export default TdDateRender;
